import { queryAll, query, fromId } from '../utils/utils.js';
//adapted from https://www.advancedcustomfields.com/resources/google-map/


export class LinksAndButtons {

	constructor() {

	}

	addArrowToLearnMoreLinks() {

		// look for anchor tag with the content "Learn More"
		const learnMoreLinks = document.querySelectorAll('a');
		learnMoreLinks.forEach((learnMoreLink) => {
			if (learnMoreLink.textContent === 'Learn More' && !learnMoreLink.classList.contains('bhs-link-button')) {
				learnMoreLink.classList.add('bhs-link-button');
				learnMoreLink.classList.add('arrow-link');
				learnMoreLink.classList.add('text-btn');
			}
		} );

	}

	addArrowLinks() {
		const menuLinkAllItems = document.querySelectorAll('.menu-item.menu-view-all-link');
		menuLinkAllItems.forEach((menuLinkAllItem) => {
			menuLinkAllItem.querySelector('a').classList.add('arrow-link');
			menuLinkAllItem.querySelector('a').classList.add('bhs-link-button');
			menuLinkAllItem.querySelector('a').classList.add('text-btn');
			menuLinkAllItem.querySelector('a').classList.add('light');
		} );


		const arrowLinks = document.querySelectorAll('.arrow-link');

		// Loop through each arrow-link element
		arrowLinks.forEach((arrowLink) => {
			
			if (arrowLink.querySelector('.link-title') && arrowLink.querySelector('.link-title').innerHTML === '' ) {
				arrowLink.querySelector('.link-title').remove();
				if (!arrowLink.classList.contains('icon-btn')) {
					arrowLink.classList.add('icon-btn');
				}
			}

			if (arrowLink.classList.contains('icon-btn')) {
				
				if (arrowLink.querySelector('.link-title') ) {
					if( arrowLink.querySelector('.link-title').textContent !== '') {
						arrowLink.ariaLabel = arrowLink.querySelector('.link-title').textContent;
					}

					
					arrowLink.querySelector('.link-title').remove();


				}
			}

			if (!arrowLink.classList.contains('arrow-link--added')) {
				const divA = document.createElement('div');
				const divL = document.createElement('div');
				const divH = document.createElement('div');

				divA.className = 'a';
				divA.setAttribute('aria-hidden', 'true');
				divL.className = 'l';
				divH.className = 'h';

				arrowLink.appendChild(divA);
				divA.appendChild(divL);
				divL.appendChild(divH);
				arrowLink.classList.add('arrow-link--added');
			}

			
		});
	}


}
